import { TLCEvents } from "../../../../js/lib/events/events";
import { BaseView } from "../../ls2pac/views/BaseView";
import { LS2KIDS_CONSTANTS } from "../constants";
import { JSIScroll } from "../controls/JSIScroll";
import { ThemeHolder } from "../themes/ThemeHolder";

/**
 * The main home screen contains the series icon layout.
 * tlc.ls2kids.views.BaseGridView
 */
export class KidsBaseGridView extends BaseView {
  constructor(options) {
    super(options);

    $.extend(
      this,
      {
        scrollWrapperId: null,
        listId: null,

        itemConstructor: null,

        _desiredFullCellHeight: null,
        _desiredFullCellWidth: null,

        _desiredIconColMargin: null,
        _desiredIconRowMargin: null,

        absoluteCenter: true,
        minimumRows: 2,
        minimumCols: 2,

        distributeMargin: 0,
        distributeSize: 0,

        distributeMarginEvenly: false,
        distributeSizeEvenly: false,
      },
      options
    );
  }
  /**
   * When the template is rendered, we want to add the icons.
   *
   * @override
   */
  baseTemplateRenderCallback() {
    super.baseTemplateRenderCallback(arguments);

    // now that these elements have loaded from the template, get them.
    this._$scrollWrapperEle = $("#" + this.scrollWrapperId);
    this._$listEle = $("#" + this.listId);

    this._$prevButton = this.$view.find(".prev");
    this._$nextButton = this.$view.find(".next");

    this._createiScroll();
    this._createIcons();
    this._addEvents();
  }

  /**
   * When the view loads, we refresh the grid to be sure things are aligned properly.
   *
   * @override
   */
  load() {
    window.requestAnimationFrame(() => {
      this.refreshGrid();

      this.$view.addClass("loaded");
    });
  }
  /**
   * Add pager and resize event handlers.
   *
   * @private
   */
  _addEvents() {
    var _this = this;

    $(window)
      .on("orientationchange", function () {
        if (_this.isActive) {
          _this.refreshGrid();
        }
      })

      .on("resize", function () {
        if (_this._resizeTimeout != null) {
          clearTimeout(_this._resizeTimeout);
        }

        _this._resizeTimeout = setTimeout(function () {
          if (_this.isActive) {
            _this.refreshGrid();
          }
        }, 150);
      })

      .on("keydown", function (e) {
        if (!_this.isActive || e.target.tagName.toLowerCase() == "input") {
          return;
        }

        if (e.keyCode == 39) {
          /* right arrow key */
          _this._iScroll.next();

          TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onGridViewNextPage, {
            name: _this.analyticsTrackingName,
            type: "keypress",
          });
        } else if (e.keyCode == 37) {
          /* left arrow key */
          _this._iScroll.prev();

          TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onGridViewPrevPage, {
            name: _this.analyticsTrackingName,
            type: "keypress",
          });
        }
      });

    this.$view
      .on("click", ".next", function (e) {
        e.preventDefault();

        TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onGridViewNextPage, {
          name: _this.analyticsTrackingName,
          type: "click",
        });

        _this._iScroll.next();
      })

      .on("click", ".prev", function (e) {
        e.preventDefault();

        TLCEvents.trigger(LS2KIDS_CONSTANTS.Events.onGridViewPrevPage, {
          name: _this.analyticsTrackingName,
          type: "click",
        });

        _this._iScroll.prev();
      });
  }

  /**
   * Create all the icons for each item and decorate the items
   */
  _createIcons(){
	this._$listEle.empty();

    var layoutItems = this._getLayout();

    this._icons = [];

    for (var i = 0, len = layoutItems.length; i < len; i += 1) {
      var layoutItem = layoutItems[i];
      var item = this._getItemById(layoutItem.id);

      var icon = new this.itemConstructor(item, layoutItem);

      this._icons.push(icon);

      icon.index = layoutItem.index;
      icon.page = Math.floor(icon.index / this._iconsPerPage);

      icon.render();

      this._$listEle.append(icon.element);
    }
  }
  /**
   * Refresh the grid. Will guarantee it shows properly.
   */
  refreshGrid() {
    //	this._calculateCellSize();
    this._recalculateGrid();
    this._alignIconsToGrid();
    this._refreshiScroll();
    this._disabledArrowState();

    //	tlc.eventManager.fireEvent( LS2KIDS_CONSTANTS.Events.onGridRefresh, {
    //		rows: this._rows,
    //		cols: this._columns
    //	} );
  }
  /**
   * Align icons to grid
   * @param {tlc.ls2kids.model.SeriesIcon} icon
   * @private
   */
  _alignSeriesIcon(icon) {
    icon.col = icon.index % this._columns;
    icon.row = Math.floor(
      (icon.index - this._columns * this._rows * icon.page) / this._columns
    );

    icon.left =
      icon.col * this.iconColumnMargin + // total margin
      icon.col * this._fullCellWidth + // total width
      icon.page * this.pageWidth + // total width of page
      this._extraLeft; // extra for horizontal centering

    icon.top =
      icon.row * this.iconRowMargin + // the row its own
      icon.row * this._fullCellHeight + // the total amount of icon heights in the row
      this._extraTop; // extra for vertical centering
  }
  /**
   * Recalculate the icon sizes based on the current available width/height of the view.
   * @private
   */
  _calculateCellSize() {
    var targetSize = {
      width: 924,
      height: 366,
    };

    var resolution = {
      width: this.$view.width(),
      height: this.$view.height(),
    };

    var squaredPixelsActual = resolution.height * resolution.width;
    var squaredPixelsTarget = targetSize.width * targetSize.height;

    var percentage = Math.max(squaredPixelsActual / squaredPixelsTarget, 0.7); // Math.min( ,  1 );

    if (percentage < 1) {
      this._fullCellWidth = this._fullCellWidth * percentage;
      this._fullCellHeight = this._fullCellHeight * percentage;

      this._desiredIconRowMargin = this._desiredIconRowMargin * percentage;
      this._desiredIconColMargin = this._desiredIconColMargin * percentage;
    }
  }
  /**
   * Enable or disable the arrow depending on the current page.
   */
  _disabledArrowState() {
    var currentPage = this._iScroll.currentPage.pageX;

    if (currentPage == 0) {
      this._$prevButton.addClass("disabled");
    } else {
      this._$prevButton.removeClass("disabled");
    }

    if (currentPage == this._iScroll.pages.length - 1) {
      this._$nextButton.addClass("disabled");
    } else {
      this._$nextButton.removeClass("disabled");
    }
  }
  /**
   * Calculates the grid dimensions, margins, and page dimensions based on the current size of the browser.
   * This should run after the element is loaded.
   *
   * @private
   */
  _recalculateGrid() {
    this.pageWidth = this._$scrollWrapperEle.width();
    this.pageHeight = this._$scrollWrapperEle.height();

    // calculate how many columns
    var cellWidthAndMargin =
      this._desiredFullCellWidth + this._desiredIconColMargin;
    var pageWidthExtraMargin = this.pageWidth + this._desiredIconColMargin;
    var columns = Math.floor(pageWidthExtraMargin / cellWidthAndMargin);

    if (columns < this.minimumCols) {
      columns = this.minimumCols;
    }

    this._columns = columns;

    // calculate how many rows
    var cellHeightAndMargin =
      this._desiredFullCellHeight + this._desiredIconRowMargin;
    var pageHeightExtraMargin = this.pageHeight + this._desiredIconRowMargin;
    var rows = Math.floor(pageHeightExtraMargin / cellHeightAndMargin);

    if (rows < this.minimumRows) {
      rows = this.minimumRows;
    }

    this._rows = rows;

    this._iconsPerPage = rows * columns;

    // now that the base grid exists, lets distribute the extra space
    var pageWidthUsed = columns * cellWidthAndMargin;
    var pageHeightUsed = rows * cellHeightAndMargin;

    this._fullCellHeight = this._desiredFullCellHeight; // + extraHeight;
    this._fullCellWidth = this._desiredFullCellWidth; // + extraWidth;

    this.iconRowMargin = this._desiredIconRowMargin;
    this.iconColumnMargin = this._desiredIconColMargin;

    this._extraLeft = 0;
    this._extraTop = 0;

    var extraHeight = pageHeightExtraMargin - pageHeightUsed;
    var extraWidth = pageWidthExtraMargin - pageWidthUsed;

    if (this.distributeMargin) {
      var extraRowMargin = Math.floor(
        (this.distributeMargin * extraHeight) / rows
      );
      var extraColumnMargin = Math.floor(
        (this.distributeMargin * extraWidth) / columns
      );

      if (this.distributeMarginEvenly) {
        extraColumnMargin = extraRowMargin = Math.min(
          extraRowMargin,
          extraColumnMargin
        );
      }

      this.iconRowMargin += extraRowMargin;
      this.iconColumnMargin += extraColumnMargin;

      extraHeight -= extraRowMargin * rows;
      extraWidth -= extraColumnMargin * columns;
    }

    if (this.distributeSize) {
      var extraSizeHeight = Math.floor(
        (this.distributeSize * extraHeight) / rows
      );
      var extraSizeWidth = Math.floor(
        (this.distributeSize * extraWidth) / columns
      );

      if (this.distributeSizeEvenly) {
        extraSizeWidth = extraSizeHeight = Math.min(
          extraSizeHeight,
          extraSizeWidth
        );
      }

      this._fullCellHeight += extraSizeHeight;
      this._fullCellWidth += extraSizeWidth;

      extraHeight -= extraSizeHeight * rows;
      extraWidth -= extraSizeWidth * columns;
    }

    if (this.absoluteCenter) {
      this._extraTop = Math.floor(extraHeight / 2);
      this._extraLeft = Math.floor(extraWidth / 2);
    }
  }
  /**
   *
   * @private
   */
  _alignIconsToGrid() {
    var lastPage = -1,
      totalPages = 0;

    for (var i = 0; i < this._icons.length; i++) {
      var icon = this._icons[i];

      icon.page = Math.floor(icon.index / this._iconsPerPage);

      this._alignSeriesIcon(icon);

      icon.resize(
        this._fullCellWidth,
        this._fullCellHeight,
        this.iconRowMargin,
        this.iconColumnMargin
      );

      if (icon.page != lastPage) {
        totalPages++;
        lastPage = icon.page;
      }
    }

    this.totalPages = totalPages;
  }
  /****************************************************************************
   * iScroll
   ****************************************************************************/
  /**
   * Create a new iScroll element, this handles all the carousel related stuff.
   *
   * @private
   */
  _createiScroll() {
    if (window.Modernizr.csstransitions) {
      this._iScroll = new window.IScroll("#" + this.scrollWrapperId, {
        scrollX: true,
        scrollY: false,
        click: true,

        snap: true,
        snapSpeed: 750,
        snapThreshold: 0.05,

        indicators: this.getIndicators(),

        vScroll: false,
        momentum: false,
      });
    } else {
      this._iScroll = new JSIScroll("#" + this.scrollWrapperId);
    }

    this._iScroll.on("scrollEnd", this.scrollEnd, this);
  }
  /**
   * Callback function for when iScroll has finished scrolling.
   */
  scrollEnd() {
    this._disabledArrowState();
  }
  /**
   * Refresh the iScroll dimensions and positioning. This should be called after recalculate grid.
   *
   * @private
   */
  _refreshiScroll() {
    this._$listEle.css({
      width: this.pageWidth * this.totalPages,
      height: this.pageHeight,
    });

    this._iScroll.refresh();
  }
  getIndicators() {
    var indicators = [];

    var clouds = ThemeHolder.activeTheme.clouds;
    for (var i = 0, len = clouds.length; i < len; i += 1) {
      var cloud = clouds[i];
      var width = cloud.element.width();
      var percent = 1 - width / 300;
      indicators.push({
        el: cloud.element.get(0),
        resize: false,
        ignoreBoundaries: true,
        speedRatioX: -(Math.random() * 0.05 * percent + 0.1),
      });
    }

    //	for( i = 0, len = trees.length; i < len; i += 1 ) {
    //		var tree = trees[ i ];
    //		var treeWidth = tree.element.width();
    //		var treePercent = 1 - treeWidth / 300;
    //		indicators.push( {
    //			el:               tree.element.get( 0 ),
    //			resize:           false,
    //			ignoreBoundaries: true,
    //			speedRatioX:      -0.05
    //		} );
    //	}
    indicators.push({
      el: $(".grass-wrap").get(0),
      resize: false,
      ignoreBoundaries: true,
      speedRatioX: -0.2,
    });

    //	indicators.push( {
    //		el:               $( '.sun-wrap' ).get( 0 ),
    //		resize:           false,
    //		ignoreBoundaries: true,
    //		speedRatioX:      0.05
    //	} );
    return indicators;
  }
}

/**
 * @private
 * @type {tlc.plugins.iScroll}
 */
KidsBaseGridView.prototype._iScroll = null;

/**
 * @private
 * @type {jQuery}
 */
KidsBaseGridView.prototype._$scrollWrapperEle = null;

/**
 * @private
 * @type {jQuery}
 */
KidsBaseGridView.prototype._$listEle = null;

/**
 * @private
 * @type {Array.<tlc.ls2kids.model.SeriesIcon>}
 */
KidsBaseGridView.prototype._icons = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._fullCellWidth = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._fullCellHeight = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._desiredFullCellWidth = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._desiredFullCellHeight = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._desiredIconRowMargin = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._desiredIconColMargin = null;

/**
 * @private
 * @type {number}
 */
KidsBaseGridView.prototype._desiredIconColMargin = null;

KidsBaseGridView.prototype._extraLeft = null;

KidsBaseGridView.prototype._extraTop = null;

/**
 * Template and Events
 */

/**
 * @private
 * @type {number|null}
 */
KidsBaseGridView.prototype._resizeTimeout = null;

/**
 *
 * @type {Function}
 * @private
 */
KidsBaseGridView.prototype.itemConstructor = null;
